import styled from 'styled-components';

export const Container = styled.div`
  padding: 0.5rem 0;
`;

export const FileName = styled.p`
  word-break: break-all;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  flex: 1;
  margin: 0 0 12px 0;

  p {
    margin: 0 0 0 8px;
    color: ${({ theme }) => theme.colors.darkBlue};
  }

  svg {
    height: 1.5rem;
    flex-shrink: 0;

    path {
      fill: ${({ theme }) => theme.colors.lightBlue};
    }
  }
`;

export const StatusLabel = styled.p`
  margin: 0.25rem 2px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.darkBlue};
`;
